import { render, staticRenderFns } from "./MejoraRegulatoria2024.vue?vue&type=template&id=0bf4d0fe&"
import script from "./MejoraRegulatoria2024.vue?vue&type=script&lang=js&"
export * from "./MejoraRegulatoria2024.vue?vue&type=script&lang=js&"
import style0 from "./MejoraRegulatoria2024.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports